import mobileApi from '@/apis/mobileApi'

/** 제휴사 정보 — 제휴 회원이 아니면 null */
export interface UserInfoBiz {
  benefitPolicyId: number
  id: number
  isActive: boolean
  name: string
}

/** 건물 연동 정보 */
export interface UserInfoBuildingContract {
  benefitPolicyId: number
  companyName: string
  id: number
  isActive: boolean
  isAddressMatched: boolean
}

/** 멤버십 정보 */
export interface UserInfoMembership {
  benefitCouponCount: number
  benefitCouponPolicyId: number
  createdAt: string
  deletedAt: string | null
  id: number
  isDemotion: number
  isScheduled: number
  level: number
  name: string
  paymentCountPeriod: number
  requiredPaymentCount: number
  updatedAt: string
}

export interface UserInfoRatingAlert {
  isRatingAlert: boolean
}

/**
 * mobile-api `GET /user` 응답 — 유저 정보.
 *
 * 대표 지번 주소 등록 여부는 `address`/`pastAddress` 필드로 판별한다 (둘 다 빈 값이면 미등록).
 * 응답에는 phone/email/birth/socialId 등 PII가 포함된다 — Sentry context·로깅에 그대로 넣지 말 것.
 */
export interface UserInfo {
  address: string
  addressBuildingName: string
  addressPassword: string
  addressPasswordType: string
  allPoint: number
  birth: string
  biz: UserInfoBiz | null
  boxDeliveredCount: number
  buildingContract: UserInfoBuildingContract | null
  byCardKey: boolean
  callTicket: number
  cautionLink: string
  detailAddress: string
  email: string
  firstDateTime: string
  gender: boolean
  gotFreeCallTicket: boolean
  gotFreeDelivery: boolean
  hasNewVoucherPayment: boolean
  isAlreadyApplied: boolean
  isNewUser: boolean
  isServiceAreaUser: boolean
  isValidDelivery: boolean
  isValidFreeCallTicket: boolean
  isValidFreeDelivery: boolean
  isValidParticipatingEvent: boolean
  isValidRetrieve: boolean
  lastCollectionDate: string
  lat: string
  lng: string
  membership: UserInfoMembership
  name: string
  no: number
  numberOfCollectDone: number
  pastAddress: string
  phone: string
  privateKey: string
  ratingAlert: UserInfoRatingAlert
  receiveHomeCall: boolean
  receiveNoti: boolean
  receivePhoneCall: boolean
  regDate: string
  remainingItems: number
  serviceUsingPeriod: number
  social: number
  socialId: string
  status: number
  totalReducedCarbon: string
  treeByReducedCarbon: string
  unPaidWeightBill: boolean
  zipcode: string
}

/**
 * 유저 정보 조회 — mobile-api `GET /user`.
 *
 * mobile-api는 envelope이 없어 응답 바디가 곧 UserInfo 객체다.
 */
export const apiGetUserInfo = async (): Promise<UserInfo> => {
  const { data } = await mobileApi.get<UserInfo>('/user')
  return data
}
